import { t } from "@redotech/redo-i18n";
import { TemplateType } from "@redotech/redo-marketing-templates-common/email-builder";

export function getTemplateTypeLabel(templateType: TemplateType): string {
  switch (templateType) {
    case TemplateType.TRANSACTIONAL:
      return t("Transactional", { context: "message template type" });
    case TemplateType.MARKETING:
      return t("Marketing", { context: "message template type" });
    case TemplateType.RECOVER:
      return t("Recover", { context: "message template type" });
    case TemplateType.DEFAULT:
      return t("Default", { context: "message template type" });
  }
}
